<template>
  <button v-if="!to" class="primary-button"><slot /></button>
  <router-link class="primary-button" v-else :to="to"><slot /></router-link>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    to: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.primary-button {
  border: none;
  outline: none;
  border-radius: 6px;
  padding: 12px 24px;
  background: #7457ff;
  color: white;
  font-size: 15px;
  font-weight: 600;
  font-family: Gilroy, sans-serif;
  transition: all 0.3s ease;
  border: 1px solid #7457ff;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: #644cdf;
    border-color: #644cdf;
  }
}
</style>
